// extracted by mini-css-extract-plugin
export default {"container":"Ap-z","brandName":"Bp-z","productName":"Cp-z","productNamePdpEnhancements":"Dp-z","breakLongProductName":"Ep-z"};